import { motion } from "framer-motion";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../hooks/ThemeContext";
import { ArrowRight, Palette, ShoppingBag } from "lucide-react";

const CTASection = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <section className="py-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className={`relative overflow-hidden p-8 md:p-12 shadow-xl ${isDark ? "bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20 border border-white/10" : "bg-white/95 border border-rose-100/80 shadow-[0_24px_70px_rgba(15,23,42,0.08)]"}`}> 
          <div className={`pointer-events-none absolute -right-20 -top-20 h-52 w-52 rounded-full blur-3xl ${isDark ? 'bg-rose-500/15' : 'bg-rose-100/80'}`} />
          <div className={`pointer-events-none absolute -left-10 bottom-0 h-40 w-40 rounded-full blur-3xl ${isDark ? 'bg-purple-500/10' : 'bg-[#fff1eb]'}`} />
          <div className="relative z-10">
          <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <div className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs uppercase tracking-[0.2em] ${isDark ? 'bg-white/5 text-white/70 border border-white/10' : 'bg-white text-rose-600 border border-rose-100'}`}>
                Passez à l’action
              </div>
              <h2 className={`mt-4 text-3xl md:text-4xl font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                Une homepage plus élégante et plus premium
              </h2>
            </div>
            <p className={`max-w-xl text-sm md:text-base ${isDark ? 'text-white/65' : 'text-gray-600'}`}>
              Choisissez votre entrée : acheter une création immédiatement ou rejoindre la plateforme comme créateur.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center ">
            {/* Acheteurs */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className={`shadow-xl bg-white/5 p-6 border ${isDark ? "bg-white/[0.05] border-white/10" : "bg-[#fff7f4] border-rose-100"}`}
            >
              <div className={`inline-block p-3 rounded-xl mb-4 shadow-xl ${isDark ? "bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20 border border-white/10" : "bg-white"}`}>
                <ShoppingBag className={`w-8 h-8 ${isDark ? "text-white" : "text-rose-600"}`} />
              </div>
              <h3 className="text-2xl font-semibold mb-3">
                Vous cherchez des créations ?
              </h3>
              <p className={`mb-6 ${isDark ? "text-white/70" : "text-gray-600"}`}>
                Explorez notre marketplace et trouvez la création parfaite pour votre projet parmi des centaines d'options.
              </p>
              <Link 
                to="/shop"
                onClick={() => window.scrollTo(0, 0)}
                className="inline-flex items-center gap-2 px-6 py-3 font-semibold transition-all hover:scale-105 shadow-xl"
                style={{ background: isDark ? '#f43f5e' : '#e11d48', color: '#fff' }}
              >
                Explorer la Boutique
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>

            {/* Créateurs */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className={`shadow-xl bg-white/5 p-6 border ${isDark ? "bg-white/[0.05] border-white/10" : "bg-white border-rose-100"}`}
            >
              <div className={`inline-block p-3 rounded-xl mb-4 shadow-xl ${isDark ? "bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20 border border-white/10" : "bg-white"}`}>
                <Palette className={`w-8 h-8 ${isDark ? "text-white" : "text-rose-600"}`} />
              </div>
              <h3 className="text-2xl font-semibold mb-3">
                Vous êtes créateur ?
              </h3>
              <p className={`mb-6 ${isDark ? "text-white/70" : "text-gray-600"}`}>
                Rejoignez notre communauté et commencez à vendre vos créations. Inscription gratuite, commissions équitables.
              </p>
              <Link 
                to="/devenir-createur"
                onClick={() => window.scrollTo(0, 0)}
                className={`inline-flex items-center gap-2 px-6 py-3 border font-semibold transition-all hover:scale-105 shadow-xl ${
                  isDark ? "border-white/30 bg-white/5 text-white hover:bg-white/10" : "border-gray-900 text-gray-900 hover:bg-white"
                }`}
              >
                Devenir Créateur
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
